import React from 'react';

import { FieldSet, FormHelp, Heading, Legend, Spacer } from '@zillow/constellation';

import SwitchWithTitle from './SwitchWithTitle';
import type { SwitchObject } from '../../models/Types';

type Props = {
  switches: Array<SwitchObject>;
  title?: string;
  legend: string;
  description?: string;
  noBottomMargin?: boolean;
  optional?: boolean;
};

export default function SwitchesWithTitle({
  switches,
  title,
  legend,
  description,
  noBottomMargin,
  optional,
}: Props): JSX.Element {
  return (
    <>
      <Heading level={6}>{title}</Heading>
      <FieldSet legend={<Legend optional={optional}>{legend}</Legend>} description={<FormHelp>{description}</FormHelp>}>
        {switches.map(
          (sw: SwitchObject, index): React.ReactNode => (
            <React.Fragment key={index}>
              <SwitchWithTitle {...sw} />
              {!(noBottomMargin && index === switches.length - 1) && <Spacer marginBottom="sm" />}
            </React.Fragment>
          ),
        )}
      </FieldSet>
    </>
  );
}
